/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-26 09:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Page,
  PageActions,
  Layout,
  Stack,
  Button,
  Icon,
  Card,
  Tabs,
  TextContainer,
  SkeletonBodyText,
  SkeletonDisplayText
} from '@shopify/polaris';
import { QuestionMarkMajor, PlayCircleMajor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { reduxForm, reset, Field, getFormValues, change } from 'redux-form';
import history from 'src/routes/history';

import { ADDONS_INFO, AI_POWERED_SEARCH_NAME } from 'src/constants/subscription';
import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import LayoutSettings from 'src/components/views/instant-search-widget/layout-settings';
import SearchBoxOnClick from 'src/components/views/instant-search-widget/search-box-onclick';
import ISWWithoutResults from 'src/components/views/instant-search-widget/isw-without-results';
import ISWWithResults from 'src/components/views/instant-search-widget/isw-with-results';
import GrantPermissionsNotify from 'src/components/views/instant-search-widget/grant-permissions-notif';
import InvalidInputBanner from 'src/components/views/instant-search-widget/invalid-input-banner';
import TypeFormEmbedded from 'src/components/views/common/typeform-embedded';
import YoutubeModal from 'src/components/views/common/youtube-modal';
import RouteLeavingGuard from 'src/components/views/common/handle-leave/route-leaving-guard';
import TitleHelp from 'src/components/views/common/title-help';
import DidYouKnow from 'src/components/views/instant-search-widget/common/did-you-know';

import * as FilterSettingsActions from 'actions/filter-settings-actions';
import * as TranslationActions from 'actions/translation-actions';
import * as checklistActions from 'actions/dashboard/checklist-actions';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';
import * as quickStartGuideAction from 'actions/dashboard/quick-start-guide-action';

import { URL } from 'src/constants/links';
import { getShop, buildUpdateAppPermissionURL, confirmLeavePage } from 'src/helpers';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';
import {
  buildInitialInstantSearchDisplayValues,
  buildInstantSearchDisplayValues,
  checkValidateInstantSearchDisplay
} from 'src/helpers/instant-search-display-helper';
import { initAnalyticDataToStorage } from 'src/helpers/analytics-v2-helpers';
import { checkShopifyTestPlan } from 'src/helpers/subscription-v3-helper.js';
import { hasPermissionContent } from 'src/helpers/permission-helper';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';
import Emitter, { EVENT_KEY } from 'src/libs/eventEmitter';
import { routes } from 'src/routes';

// Render component
const InstantSearchWidget = props => {
  const {
    dirty,
    submitting,
    handleSubmit,
    pristine,
    saving,

    loading,
    resetForm,
    updateField,
    formValues,
    localeLoading,
    accessScopes,
    successSave,
    enableSuggestion,
    currentEnableSuggestion,
    enableProducts,
    suggestionBlocks,
    enableSearchBoxRecentSearch,
    enableSearchBoxSearchTermSuggestions,
    searchBoxSearchTermSuggestionsList,
    searchBoxSearchTermSuggestionsType,
    enableSearchBoxProductSuggestions,
    searchBoxProductSuggestionsList,
    searchBoxProductSuggestionsType,
    enableSearchTermSuggestions,
    enableProductSuggestions,
    searchTermSuggestionsList,
    searchTermSuggestionsType,
    productSuggestionsList,
    productSuggestionsType,
    notThemeSetupV1,
    suggestionStyle,
    suggestionStyle1ProductItemType,
    suggestionStyle2ProductItemType,
    suggestionStyle2ProductPosition,
    suggestionStyle2ProductPerRow,
    suggestionStyle3ProductItemType,
    suggestionStyle3ProductPosition,
    suggestionStyle3ProductPerRow,
    invoice,
    addonStatus,
    selectedPlan,
    enableAISearch,
    statusStore,
    getAddonStatus,
    planName,
    tenantId = '',
    allowSearchV2,
    updateFilterSettings,
    getFilterSettings,
    getLocales,
    getDetailInvoice,
    filterSettings,
    primaryLocale,
    getChecklist,
    searchVersion,
    markDoneStep,
    isEnableShopifyIntegration,
    i18n
  } = props;

  const [selected, setSelected] = useState(0);
  const [modalAddon, setModalAddon] = useState(false);
  const [activePermissionNotify, setActivePermissionNotify] = useState(false);
  const [permissionURL, setPermissionURL] = useState('');
  const [dismissedBanner, setDismissedBanner] = useState(true);
  const [messageError, setMessageError] = useState('');
  const [discardState, setDiscardState] = useState(0);
  const [youtubeModal, setYoutubeModal] = useState(false);
  const [youtubeModalDisplaySettings, setYoutubeModalDisplaySettings] = useState(false);

  // Get current status addon
  const addonRemainingCycles = _.get(addonStatus, 'trialInfo.remainingDays', 14);
  const isSubscribeNow =
    !['trial', 'expiredSoon'].includes(statusStore) && addonRemainingCycles <= 0;

  const disableLockUnLock =
    (checkShopifyTestPlan(planName, tenantId) && ['trial', 'expiredSoon'].includes(statusStore)) ||
    statusStore === 'expired';

  let tabs = [
    {
      id: 'iswWithResults',
      content: i18n.translate('AdminHTML.InstantSearchDisplay.InstantSearchWidget.tab1_Content'),
      panelID: 'iswWithResults'
    }
  ];
  const isDisableSuggestion = enableAISearch && !allowSearchV2;

  // Handle click save button
  const handleSave = async data => {
    const validateInstantSearchDisplayResult = checkValidateInstantSearchDisplay(data, i18n);

    if (!_.isEmpty(validateInstantSearchDisplayResult)) {
      setDismissedBanner(false);
      setMessageError(validateInstantSearchDisplayResult);
      return;
    }

    setDismissedBanner(true);
    setMessageError('');

    const dataSaved = buildInstantSearchDisplayValues(
      data,
      filterSettings,
      notThemeSetupV1,
      primaryLocale
    );
    const { searchBoxProductSuggestionsList = [], productSuggestionsList = [] } = data;
    const productBackup = _.get(dataSaved, 'search.suggestionNoResult.products.backup', []);
    // Tracking event enable instant search widget
    const enableSuggestionSaved = _.get(dataSaved, 'search.enableSuggestion', true);
    const isEnableSuggestionTracking =
      currentEnableSuggestion === false && enableSuggestionSaved === true;

    await updateFilterSettings(
      dataSaved,
      productSuggestionsList,
      searchBoxProductSuggestionsList,
      productBackup,
      isEnableSuggestionTracking
    );
    await getChecklist();

    markDoneStep('V2_SEARCH1', {
      isDone: true
    });

    Emitter.emit(EVENT_KEY.RELOAD_CSAT_ADMIN_APP_DISPLAY);
  };

  // Handle discard button
  const discardChange = () => {
    resetForm();
    setDiscardState(discardState + 1);
  };

  // Show notification
  const showGrantPermissionsModalNotify = () => {
    // Remove localStorage
    try {
      localStorage.removeItem(`${getShop()}-permissionApproval-redirectURI`);
    } catch (error) {}

    // Check permission from access scopes' tenant app
    if (hasPermissionContent(accessScopes)) return;

    // Get update permission link
    const permissionURLValue = buildUpdateAppPermissionURL(getShop());

    setActivePermissionNotify(true);
    setPermissionURL(permissionURLValue);
  };

  /**
   * Swap options between display based on data and manually setting
   * Mainly idea is keep previous setting for customer when swap between 2 options
   * @param {*} type
   */
  const swapOptionValues = (type: string) => {
    if (type === 'searchTerm') {
      let searchTerms = _.get(formValues, 'searchTermSuggestionsList', []);
      let backup = _.get(formValues, 'searchTermSuggestionsBackup', []);
      // Swap backup data and main data
      [backup, searchTerms] = [searchTerms, backup];

      updateField('searchTermSuggestionsList', searchTerms);
      updateField('searchTermSuggestionsBackup', backup);
    } else if (type === 'product') {
      let products = _.get(formValues, 'productSuggestionsList', []);
      let backup = _.get(formValues, 'productSuggestionsBackup', []);
      // Swap backup data and main data
      [backup, products] = [products, backup];

      updateField('productSuggestionsList', products);
      updateField('productSuggestionsBackup', backup);
    }

    if (type === 'searchBoxSearchTermSuggestion') {
      let products = _.get(formValues, 'searchBoxSearchTermSuggestionsList', []);
      let backup = _.get(formValues, 'searchBoxSearchTermSuggestionsBackup', []);
      // Swap backup data and main data
      [backup, products] = [products, backup];

      updateField('searchBoxSearchTermSuggestionsList', products);
      updateField('searchBoxSearchTermSuggestionsBackup', backup);
      return;
    }

    if (type === 'searchBoxProductSuggestion') {
      let products = _.get(formValues, 'searchBoxProductSuggestionsList', []);
      let backup = _.get(formValues, 'searchBoxProductSuggestionsBackup', []);
      // Swap backup data and main data
      [backup, products] = [products, backup];

      updateField('searchBoxProductSuggestionsList', products);
      updateField('searchBoxProductSuggestionsBackup', backup);
      return;
    }
  };

  /** Subscribe addon - reload page*/
  const handleCloseStatus = () => {
    getAddonStatus(AI_POWERED_SEARCH_NAME);
  };

  // Handle confirm leave page
  const handleConfirmLeavePage = event => {
    return confirmLeavePage(event, dirty, i18n);
  };
  // useEffect

  useEffect(() => {
    // Get locales
    const processFunction = async () => {
      // get addon status
      getAddonStatus(AI_POWERED_SEARCH_NAME);

      // Get detail invoice
      if (_.isEmpty(invoice) || !invoice) {
        getDetailInvoice();
      }
      await Promise.all([getLocales(), getFilterSettings()]);

      // Show Grant permission notification
      showGrantPermissionsModalNotify();
      // Get analytic data
      initAnalyticDataToStorage(i18n);
    };
    processFunction();

    // Handle when reload or leave page
    window.addEventListener('beforeunload', handleConfirmLeavePage);
    // Handle when reload or leave page
    return () => window.removeEventListener('beforeunload', handleConfirmLeavePage);
  }, []);

  // component
  let tabComponents = [
    <ISWWithResults
      history={history}
      enableProducts={enableProducts}
      suggestionBlocks={suggestionBlocks}
      suggestionStyle={suggestionStyle}
      updateField={updateField}
      notThemeSetupV1={notThemeSetupV1}
      subscribedAddonAIPowerSearch={enableAISearch}
      subscribedAddonBefore={isSubscribeNow}
      disableLockUnLock={disableLockUnLock}
      isDisableSuggestion={isDisableSuggestion}
      searchVersion={searchVersion}
      handleUnlock={() => {
        if (disableLockUnLock) return;
        setModalAddon(true);
      }}
    />
  ];

  // Add no search result suggestion tab when v2
  if (notThemeSetupV1) {
    tabs.push(
      {
        id: 'iwsWithoutResults',
        content: i18n.translate('AdminHTML.InstantSearchDisplay.InstantSearchWidget.tab2_Content'),
        panelID: 'iwsWithoutResults'
      },
      {
        id: 'searchBoxOnClick',
        content: i18n.translate('AdminHTML.InstantSearchDisplay.InstantSearchWidget.tab3_Content'),
        panelID: 'searchBoxOnClick'
      }
    );
    tabComponents.push(
      <ISWWithoutResults
        swapOptionValues={swapOptionValues}
        enableSearchTermSuggestions={enableSearchTermSuggestions}
        enableProductSuggestions={enableProductSuggestions}
        searchTermSuggestionsList={searchTermSuggestionsList}
        searchTermSuggestionsType={searchTermSuggestionsType}
        productSuggestionsList={productSuggestionsList}
        productSuggestionsType={productSuggestionsType}
      />,
      <SearchBoxOnClick
        enableSearchBoxRecentSearch={enableSearchBoxRecentSearch}
        enableSearchBoxSearchTermSuggestions={enableSearchBoxSearchTermSuggestions}
        searchBoxSearchTermSuggestionsList={searchBoxSearchTermSuggestionsList}
        searchBoxSearchTermSuggestionsType={searchBoxSearchTermSuggestionsType}
        enableSearchBoxProductSuggestions={enableSearchBoxProductSuggestions}
        searchBoxProductSuggestionsList={searchBoxProductSuggestionsList}
        searchBoxProductSuggestionsType={searchBoxProductSuggestionsType}
        swapOptionValues={swapOptionValues}
      />
    );
  }

  // Check data is loading
  const loadingData = loading || localeLoading;
  return (
    <div className="BC-Page BC-Page__InstantSearchDisplay">
      <Page
        title={i18n.translate('AdminHTML.InstantSearchDisplay.InstantSearchWidget.pageTitle')}
        primaryAction={
          <div className="BC-Page BC-Page__Button">
            <Stack>
              {!pristine && (
                <Button disabled={submitting} onClick={discardChange}>
                  {i18n.translate('AdminHTML.Common.Action.discard')}
                </Button>
              )}
              <Button
                primary
                onClick={handleSubmit(handleSave.bind(this))}
                disabled={pristine || submitting}
                loading={saving && !pristine}>
                {i18n.translate('AdminHTML.Common.Action.saveSettings')}
              </Button>
            </Stack>
          </div>
        }>
        <TitleHelp
          i18n={i18n}
          onPlay={() => setYoutubeModal(true)}
          hrefUserManual={URL['Link_V2_Search_InstantSearchDisplay_ManualGuide']}
          onAnalytics={() => history.push(routes.analytics.overviewSearch())}
        />
        <Layout>
          <Layout.Section>
            <div className="BC-Container__Notifications">
              {/* Did you know */}
              <DidYouKnow />
              {/* Update permission locales*/}
              {activePermissionNotify && <GrantPermissionsNotify permissionURL={permissionURL} />}
              {/* Banner error */}
              {!dismissedBanner && (
                <InvalidInputBanner
                  onDismiss={() => setDismissedBanner(true)}
                  message={messageError}
                />
              )}
            </div>
          </Layout.Section>

          <Layout.Section>
            {loadingData ? (
              <Card sectioned>
                <TextContainer>
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText />
                </TextContainer>
              </Card>
            ) : isEnableShopifyIntegration ? (
              ''
            ) : (
              <Card sectioned>
                <Field
                  name="enableSuggestion"
                  component={RenderToggleSwitch}
                  label={i18n.translate(
                    'AdminHTML.InstantSearchDisplay.InstantSearchWidget.field1_Label'
                  )}
                />
              </Card>
            )}
            {(enableSuggestion || isEnableShopifyIntegration) && !loadingData && (
              <>
                {notThemeSetupV1 && (
                  <LayoutSettings
                    updateField={updateField}
                    formValues={formValues}
                    suggestionBlocks={suggestionBlocks}
                    suggestionStyle1ProductItemType={suggestionStyle1ProductItemType}
                    suggestionStyle2ProductItemType={suggestionStyle2ProductItemType}
                    suggestionStyle2ProductPosition={suggestionStyle2ProductPosition}
                    suggestionStyle2ProductPerRow={suggestionStyle2ProductPerRow}
                    suggestionStyle3ProductItemType={suggestionStyle3ProductItemType}
                    suggestionStyle3ProductPosition={suggestionStyle3ProductPosition}
                    suggestionStyle3ProductPerRow={suggestionStyle3ProductPerRow}
                  />
                )}
                <div>
                  <Card
                    title={
                      <div>
                        <span className="headingText">
                          {i18n.translate('AdminHTML.InstantSearchDisplay.DisplaySettings.title')}
                        </span>
                        <div>
                          <span className="titleMetadata">
                            <a
                              href={URL['InstantSearchDisplayDoc']}
                              target="_blank"
                              rel="noopener noreferrer">
                              <Icon source={QuestionMarkMajor} color="base" />
                            </a>
                          </span>
                          <span className="titleMetadata">
                            <button onClick={() => setYoutubeModalDisplaySettings(true)}>
                              <Icon source={PlayCircleMajor} color="base" />
                            </button>
                          </span>
                        </div>
                      </div>
                    }>
                    <div className="tabs">
                      <Tabs tabs={tabs} selected={selected} onSelect={value => setSelected(value)}>
                        <Card.Section>{tabComponents[selected]}</Card.Section>
                      </Tabs>
                    </div>
                  </Card>
                </div>
              </>
            )}
          </Layout.Section>
        </Layout>
        <PageActions
          primaryAction={{
            content: i18n.translate('AdminHTML.Common.Action.saveSettings'),
            onAction: handleSubmit(handleSave.bind(this)),
            disabled: pristine || submitting,
            loading: saving && !pristine
          }}
          secondaryActions={
            !pristine
              ? [
                  {
                    content: i18n.translate('AdminHTML.Common.Action.discard'),
                    onAction: discardChange,
                    disabled: submitting
                  }
                ]
              : []
          }
        />
      </Page>

      <YoutubeModal
        active={youtubeModal || youtubeModalDisplaySettings}
        embeddedURL={
          youtubeModal
            ? URL['Link_V2_Search_InstantSearchDisplay_Video']
            : URL['InstantSearchDisplay_DisplaySettingsTut']
        }
        title={i18n.translate(
          youtubeModal
            ? 'AdminHTML.InstantSearchDisplay.InstantSearchDisplay.youtubeModal_Title'
            : 'AdminHTML.InstantSearchDisplay.DisplaySettings.youtubeModal_Title'
        )}
        onClose={() =>
          youtubeModal ? setYoutubeModal(false) : setYoutubeModalDisplaySettings(false)
        }
      />

      {!_.isEmpty(selectedPlan) && (
        <TypeFormEmbedded
          type="instant-search-display"
          conditionShow={successSave}
          conditionShowStateChange={discardState}
        />
      )}

      {/* Confirm before leaving */}
      <RouteLeavingGuard
        when={dirty}
        // Navigate function
        navigate={path => history.push(path)}
        shouldBlockNavigation={dirty}
      />

      {/* Process addon unlock */}
      <ProcessAddon
        openModalReview={modalAddon}
        addon={ADDONS_INFO.find(e => e.addonName === AI_POWERED_SEARCH_NAME)}
        hadSubscribed={isSubscribeNow}
        handleAfterSubscribeAddon={handleCloseStatus}
        handleReviewModal={() => setModalAddon(!modalAddon)}
      />
    </div>
  );
};

// Reducer
const InstantSearchWidgetForm = reduxForm({
  form: 'InstantSearchWidgetForm', // a unique identifier for this form
  enableReinitialize: true
})(InstantSearchWidget);

const mapDispatchToProps = (dispatch, ownProps) => ({
  // Get current status addon sync
  getAddonStatus: addonName => dispatch(subscriptionV3Actions.getAddonStatus(addonName)),
  getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n)),
  // Get current status addon sync
  getFilterSettings: () => dispatch(FilterSettingsActions.getFilterSettings(true, ownProps.i18n)),
  updateFilterSettings: (
    filterSettings: Object,
    productSuggestionsList,
    searchBoxProductSuggestionsList,
    productBackup,
    isEnableSuggestionTracking
  ) =>
    dispatch(
      FilterSettingsActions.updateFilterSettings(
        filterSettings,
        'instantSearchDisplay',
        {
          isEnableSuggestionTracking,
          suggestionsList: {
            productSuggestionsList,
            searchBoxProductSuggestionsList,
            productBackup
          }
        },
        ownProps.i18n
      )
    ),
  updateField: (field, data) => dispatch(change('InstantSearchWidgetForm', field, data)),
  resetForm: () => dispatch(reset('InstantSearchWidgetForm')),
  // Locales
  getLocales: () => dispatch(TranslationActions.getLocales(ownProps.i18n)),
  getChecklist: () => dispatch(checklistActions.getChecklist(ownProps.i18n)),
  markDoneStep: (stepName, value) =>
    dispatch(quickStartGuideAction.markDoneStep(stepName, value, ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const { filterSettings, oauth, translation } = state;
  const formValues = getFormValues('InstantSearchWidgetForm')(state);
  const enableSuggestion = formValues && formValues.enableSuggestion;
  const suggestionBlocks = formValues && formValues.suggestionBlocks;
  const products =
    formValues &&
    formValues.suggestionBlocks &&
    _.find(formValues.suggestionBlocks, item => item.type === 'products');
  const enableProducts = products && products.status === 'active';

  // Get access scopes
  const accessScopes = _.get(oauth, 'tenantApp.accessScopes', {});

  // Detect primary locale
  const primaryLocale = _.get(translation, 'primaryLocale', 'en');

  // Search box onclick
  const enableSearchBoxRecentSearch = _.get(formValues, 'enableSearchBoxRecentSearch', false);
  const enableSearchBoxSearchTermSuggestions = _.get(
    formValues,
    'enableSearchBoxSearchTermSuggestions',
    false
  );
  const searchBoxSearchTermSuggestionsList = _.get(
    formValues,
    'searchBoxSearchTermSuggestionsList',
    []
  );
  const searchBoxSearchTermSuggestionsType = _.get(
    formValues,
    'searchBoxSearchTermSuggestionsType',
    'manually'
  );
  const enableSearchBoxProductSuggestions = _.get(
    formValues,
    'enableSearchBoxProductSuggestions',
    false
  );
  const searchBoxProductSuggestionsList = _.get(formValues, 'searchBoxProductSuggestionsList', []);
  const searchBoxProductSuggestionsType = _.get(
    formValues,
    'searchBoxProductSuggestionsType',
    'manually'
  );

  // No search result
  const enableSearchTermSuggestions = _.get(formValues, 'enableSearchTermSuggestions', false);
  const enableProductSuggestions = _.get(formValues, 'enableProductSuggestions', false);
  const searchTermSuggestionsList = _.get(formValues, 'searchTermSuggestionsList', []);
  const searchTermSuggestionsType = _.get(formValues, 'searchTermSuggestionsType', 'based_on_data');
  const productSuggestionsList = _.get(formValues, 'productSuggestionsList', []);
  const productSuggestionsType = _.get(formValues, 'productSuggestionsType', 'based_on_data');
  const suggestionStyle = _.get(formValues, 'suggestionStyle', '');
  const suggestionStyle1ProductItemType = _.get(formValues, 'suggestionStyle1ProductItemType', '');
  const suggestionStyle2ProductItemType = _.get(formValues, 'suggestionStyle2ProductItemType', '');
  const suggestionStyle2ProductPosition = _.get(formValues, 'suggestionStyle2ProductPosition', '');
  const suggestionStyle2ProductPerRow = _.get(formValues, 'suggestionStyle2ProductPerRow', '');
  const suggestionStyle3ProductItemType = _.get(formValues, 'suggestionStyle3ProductItemType', '');
  const suggestionStyle3ProductPosition = _.get(formValues, 'suggestionStyle3ProductPosition', '');
  const suggestionStyle3ProductPerRow = _.get(formValues, 'suggestionStyle3ProductPerRow', '');
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const themeSetupV2 = _.get(tenantApp, 'adminAppFeatures.themeSetupV2', false);
  // const themeSetupV3 = _.get(state.oauth, 'tenantApp.settings.themeSetupV3.settings.enable', false);

  const notThemeSetupV1 = themeSetupV2;

  const initialValues = buildInitialInstantSearchDisplayValues(
    filterSettings.filterSettings,
    themeSetupV2,
    props.i18n
  );

  // Get current enableSuggestion before edit
  const currentEnableSuggestion = _.get(
    filterSettings,
    'filterSettings.search.enableSuggestion',
    false
  );
  const searchVersion = _.get(tenantApp, 'parseParams.searchVersion', '1.0');
  const allowSearchV2 = allowUsingNewSearchSettings(searchVersion);
  const tenantId = _.get(state.oauth, 'tenantApp.tenantId', '');
  const planName = _.get(state.oauth, 'tenantApp.externalInfo.plan_name', '');
  const isEnableShopifyIntegration = enableShopifyIntegration(tenantApp);

  return {
    tenantId,
    formValues,
    filterSettings: filterSettings.filterSettings,
    saving: filterSettings.savingFilterSettings,
    loading: filterSettings.loadingFilterSettings,
    localeLoading: translation.loading,
    successSave: filterSettings.successSave,
    initialValues,
    currentEnableSuggestion,
    enableSuggestion,
    allowSearchV2,
    enableProducts,
    suggestionBlocks,
    accessScopes,
    primaryLocale,
    enableSearchBoxRecentSearch,
    enableSearchBoxSearchTermSuggestions,
    searchBoxSearchTermSuggestionsList,
    searchBoxSearchTermSuggestionsType,
    enableSearchBoxProductSuggestions,
    searchBoxProductSuggestionsList,
    searchBoxProductSuggestionsType,
    enableSearchTermSuggestions,
    enableProductSuggestions,
    searchTermSuggestionsList,
    searchTermSuggestionsType,
    productSuggestionsList,
    productSuggestionsType,
    suggestionStyle,
    suggestionStyle1ProductItemType,
    suggestionStyle2ProductItemType,
    suggestionStyle2ProductPosition,
    suggestionStyle2ProductPerRow,
    suggestionStyle3ProductItemType,
    suggestionStyle3ProductPosition,
    suggestionStyle3ProductPerRow,
    statusStore: _.get(state.oauth, 'subscription.status', ''),
    addonStatus: _.get(state.subscriptionV3, 'addonStatus', {}),
    planName,
    enableAISearch: _.get(
      state.oauth.tenantApp,
      'settings.instantSearch.settings.AI-synonyms',
      false
    ),
    selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan'),
    invoice: _.get(state.subscriptionV3, 'invoice', {}),
    notThemeSetupV1,
    searchVersion,
    isEnableShopifyIntegration
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(InstantSearchWidgetForm));
